// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const RegistrationsReview = t.struct({
    accountAddress: t.maybe(t.String),
    accountNumber: t.maybe(t.String),
    city: t.maybe(t.String),
    comments: t.maybe(t.String),
    country: t.maybe(t.String),
    customerName: t.maybe(t.String),
    customerNumber: t.maybe(t.String),
    deliveryDate: t.maybe(t.Number),
    email: t.maybe(t.String),
    expectedDateOfFirstUse: t.maybe(t.Number),
    id: t.maybe(t.String),
    message: t.maybe(t.String),
    mobilePhone: t.maybe(t.String),
    phone: t.maybe(t.String),
    pin: t.maybe(t.String),
    postalCode: t.maybe(t.String),
    region: t.maybe(t.String),
    registrationDate: t.maybe(t.Number),
    registrationForm: t.maybe(t.Bool),
    registrationStatus: t.maybe(t.String),
    statusIndicator: t.maybe(t.String),
    street1: t.maybe(t.String),
    street2: t.maybe(t.String)
}, {
    name: 'RegistrationsReview',
    strict: true
});

export const getDefaultState = () => new RegistrationsReview({});

export default RegistrationsReview;




// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/registrations-review.js